export enum TypeParametreEnum {
  String128 = 'String128',
  StringCode = 'StringCode',
  StringChoix = 'StringChoix',
  Booleen = 'Booleen',
}
